import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { useCPFContributionQuery } from "AppQuries/master/CpfContribution/contributions";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const CpfContributionRateModal = ({
  mode = "I",
  onSubmit,
  show = false,
  handleClose,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();

  const { data } = useCPFContributionQuery();

  const contributionOptions = Array.isArray(data?.data)
    ? data?.data
        ?.filter((r) => r.isActive)
        .map((r) => ({
          id: r.contributionCode,
          label: r.contributionName,
          value: r.contributionCode,
        }))
    : [];

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>
            {mode === "I"
              ? "Add CPF Contribution Rate"
              : "Edit CPF Contribution Rate"}
          </h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row row">
            <div className="mb-3">
              <Input
                name="contributionCode"
                type="commonSelect"
                placeholder="Select Contribution Type"
                className={`form-control select ${
                  errors.contributionCode ? "is-invalid" : ""
                }`}
                label="Contribution Type"
                labelClassName="form-label"
                optionData={contributionOptions}
                required={true}
                requiredMessage="contribution Code is required"
                onChange={(e) => {
                  setValue("contributionCode", e);
                }}
                defaultValue={watch("contributionCode")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>

            <div className="mb-3">
              <Input
                name="rangeFrom"
                type="text"
                placeholder="Range From"
                className={`form-control ${
                  errors.rangeFrom ? "is-invalid" : ""
                }`}
                label="Range From"
                labelClassName="form-label"
                required={true}
                requiredMessage="range From is required"
                defaultValue=""
              />
            </div>

            <div className="mb-3">
              <Input
                name="rangeTo"
                type="text"
                placeholder="Range To"
                className={`form-control ${errors.rangeTo ? "is-invalid" : ""}`}
                label="Range To"
                labelClassName="form-label"
                required={true}
                requiredMessage="Range To is required"
                defaultValue=""
              />
            </div>

            <div className="mb-3">
              <Input
                name="amount"
                type="text"
                placeholder="Amount "
                className={`form-control ${errors.amount ? "is-invalid" : ""}`}
                label="Amount"
                labelClassName="form-label"
                required={true}
                requiredMessage="Amount is required"
                defaultValue=""
              />
            </div>
            <div className="mb-3">
              <Input
                name="isActive"
                type="commonSelect"
                placeholder="Status"
                className={`form-control ${
                  errors.isActive ? "is-invalid" : ""
                }`}
                label="Status"
                labelClassName="form-label"
                optionData={boolStatus}
                required={true}
                requiredMessage="Status is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue("isActive", selectedOption);
                  trigger("isActive");
                }}
                defaultValue={watch("isActive")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

CpfContributionRateModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default CpfContributionRateModal;
